import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';

import './styles.css';

const TeamTile = ({ image, name, title }) => {
    return (
        <div className="team-tile">
            {image ? (
                <Img fluid={image} />
            ) : (
                <img alt="" src="https://www.placecage.com/g/300/300" />
            )}
            <div className="name">{name}</div>
            <div className="title">{title}</div>
        </div>
    );
};

TeamTile.propTypes = {
    image: PropTypes.object,
    name: PropTypes.string,
    title: PropTypes.string,
};

export default TeamTile;
